const Lemo_Translate =
    {
        string: function (string) {
            if (string && typeof translations !== "undefined" && translations[string]) {
                return translations[string];
            } else {
                return string;
            }
        },
    }

window.Lemo_Translate || (window.Lemo_Translate = Lemo_Translate);
